import React, { useState } from 'react'
import { renderActivityLogHtml, formatActivityLog } from '@edge-stream/observability-ui'

/**
 * ActivityLogViewer - Displays activity timeline using @edge-stream/observability-ui
 *
 * Thin wrapper around renderActivityLog from library
 * Shows how easy it is to integrate observability renderers
 */
interface ActivityLogViewerProps {
  activities?: string[]
}

const defaultActivities = [
  '[OK] Inspector initialized',
  '[-->] Connecting to EdgeStream server...',
  '[...] Waiting for pipeline events',
  'Ready to display envelopes',
]

export default function ActivityLogViewer({ activities = defaultActivities }: ActivityLogViewerProps): React.ReactElement {
  const [showLineNumbers, setShowLineNumbers] = useState(true)
  const [maxEntries, setMaxEntries] = useState(100)

  const activityList = activities || []
  const { count } = formatActivityLog(activityList, {
    showLineNumbers,
    maxEntries,
  })

  const htmlContent = renderActivityLogHtml(activityList, {
    showLineNumbers,
    maxEntries,
  })

  return (
    <div className="viewer-container">
      <div className="viewer-header">
        <h3>Activity Log ({count} entries)</h3>
        <div className="controls">
          <label>
            <input
              type="checkbox"
              checked={showLineNumbers}
              onChange={(e) => setShowLineNumbers(e.target.checked)}
            />
            Line Numbers
          </label>
          <button onClick={() => setMaxEntries(prev => prev < 50 ? 100 : 50)} className="btn-secondary">
            {maxEntries === 50 ? 'Show More' : 'Show Less'}
          </button>
        </div>
      </div>

      <div className="activity-log-content">
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
      </div>
    </div>
  )
}
